import { ActivatedRouteSnapshot, Resolve, RouterStateSnapshot } from '@angular/router';
import { Injectable } from '@angular/core';

import { catchError, first, mergeMap, tap } from 'rxjs/operators';
import { ApiService } from '../services/api.service';
import { Observable, of } from 'rxjs';
import { select } from '@angular-redux/store';
import { Themes } from '../core/themes/themes.model';
import { ThemesActionService } from '../core/themes/themes.action';

@Injectable()
export class SingleThemeResolver implements Resolve<Themes> {
  @select(['theme', 'list'])
  themesList$: Observable<Themes[]>;
  isThemeInRedux = false;

  constructor(private service: ApiService,
              private themeAction: ThemesActionService) {}

  resolve(route: ActivatedRouteSnapshot, state: RouterStateSnapshot) {
    return this.themesList$.pipe(
      first(),
      mergeMap((list) => {
        const actualRoute = state.url;
        const idFromUrl = parseInt(actualRoute.split('/').pop(), 10);
        if (list.length > 0) {
          this.isThemeInRedux = true;
          return of(list.find(({id}) => id === idFromUrl));
        }
        return this.service.themeDetail(idFromUrl).pipe(first());
      }),
      tap((data: any) => {
        const themeCurrent = this.isThemeInRedux ?
          data :
          Themes.from(data);
        this.themeAction.setThemesCurrent(themeCurrent);
      }),
      catchError((err) => {
        console.error('Non è stato possibile recuperare il singolo percorso tematico');
        return of(err);
      })
    );
  }
}
